import { GenericBackendResponse } from '../genericBackendResponse';
import { IndividualPensionPlan } from './interfaces/IndividualPensionPlan';

interface SaveIndividualPensionPlanDto {
	hasIndividual: boolean;
	contributionsMade: number;
	contributionsPlanned: number;
	provider: string | null;
}

const saveIndividualPensionPlan = async (
	token: string,
	data: SaveIndividualPensionPlanDto
): Promise<GenericBackendResponse<IndividualPensionPlan>> => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_BASE_API}/users/individual-pension-plan`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`
				},
				body: JSON.stringify(data)
			}
		);

		const responseData = await response.json();

		return responseData;
	} catch (error) {
		console.error('Error saving individual pension plan:', error);
		return {
			success: false,
			data: {} as IndividualPensionPlan,
			code: 500,
			responseAt: new Date().toISOString(),
			debugId: 'individual-pension-plan-save-error',
			message: 'Error al guardar los datos del plan de pensiones individual'
		};
	}
};

export default saveIndividualPensionPlan;
